import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["accountType", "account"]
  static values = {
    classifications: Object
  }

  connect() {
    // Store all classifications grouped by account_type
    this.updateClassificationsData()
  }

  updateClassificationsData() {
    // Get all options from the account dropdown and group by account_type
    const allOptions = Array.from(this.accountTarget.options)
    this.classificationsByType = {}

    allOptions.forEach(option => {
      if (option.value === "") return // Skip blank option

      const accountType = option.dataset.accountType
      if (!this.classificationsByType[accountType]) {
        this.classificationsByType[accountType] = []
      }
      this.classificationsByType[accountType].push({
        value: option.value,
        text: option.text,
        selected: option.selected
      })
    })

    // Store original options for "All" case
    this.allClassifications = allOptions.map(option => ({
      value: option.value,
      text: option.text,
      selected: option.selected,
      dataset: option.dataset
    }))
  }

  filterByAccountType() {
    const selectedType = this.accountTypeTarget.value
    const currentValue = this.accountTarget.value

    // Clear current options
    this.accountTarget.innerHTML = ""

    // Add blank option
    const blankOption = document.createElement("option")
    blankOption.value = ""
    blankOption.text = "Select specific account..."
    this.accountTarget.appendChild(blankOption)

    let optionsToAdd = []

    if (selectedType === "") {
      // Show all classifications
      optionsToAdd = this.allClassifications.filter(opt => opt.value !== "")
    } else {
      // Filter by account type
      optionsToAdd = this.classificationsByType[selectedType] || []
    }

    // Add options
    optionsToAdd.forEach(classification => {
      const option = document.createElement("option")
      option.value = classification.value
      option.text = classification.text
      option.dataset.accountType = classification.dataset?.accountType || selectedType

      // Restore selection if it still exists
      if (classification.value === currentValue) {
        option.selected = true
      }

      this.accountTarget.appendChild(option)
    })

    // If current selection is no longer valid, reset to blank
    if (selectedType !== "" && this.accountTarget.value !== currentValue) {
      this.accountTarget.value = ""
    }
  }
}
